<template>
    <div class="container">
        <div class="header flex-row">
            <img src="../assets/img/header-logo.svg" />
            <div class="title"></div>
        </div>
        <div class="section flex-row">
            <el-carousel
                indicator-position="none"
                arrow="nerver"
                height="100%"
                :interval="5000"
                :loop="true"
                class="banner"
            >
                <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                    <img :src="require('../assets/img/' + item)" />
                </el-carousel-item>
            </el-carousel>
            <div class="flex-row content">
                <!-- <div class="tip flex-column">
					<div>智慧票务</div>
					<div><span class="space">快捷方便智慧高</span><span>效</span></div>
				</div> -->
                <div class="rightBox">
                    <!-- <div class="title">欢迎登录<span>四川大学博物馆售票系统</span></div> -->
                    <div class="inputBox">
                        <div class="img-box">
                            <img class="login-logo" src="../assets/img/header-logo.png" alt="" />
                            <img
                                @click="getExpire"
                                v-if="wxStatus == 500"
                                class="login-wxerr flex-row justifyCenter"
                                src="../assets/img/wxerr.svg"
                                alt=""
                            />
                        </div>

                        <!-- <div class="name">手 机 验 证 登 录</div> -->
                        <!-- <div class="name">二 维 码 登 录</div> -->
                        <div class="flex-row justifyCenter">
                            <img class="erImg" :src="imgUrl" alt="" />
                        </div>
                        <!-- <el-input
              class="input"
              type="text"
              v-model="CellPhone"
              placeholder="请输入您的账号"
            ></el-input>
            <el-input
              class="input"
              type="text"
              v-model="VerificationCode"
              placeholder="请输入验证码"
            >
            <el-button plain slot="suffix" :disabled="disabled" @click="getCode">
                  <span class="Time">{{btnTxt}}</span>
              </el-button>

            </el-input>
            <el-button class="login" @click="login">登录</el-button> -->
                        <!-- <div class="unitName">四川大学博物馆</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    officialWebsiteLogin,
    sendLoginCode,
    merchantNo,
    getSmallAppLoginQrCode,
    getLoginQrCodeStatus,
} from "../utils/http";
import tool from "@/utils/tools";

export default {
    name: "Login",
    components: {},
    data() {
        return {
            CellPhone: "",
            VerificationCode: "",
            bannerList: ["kjg-bg.png", "kjg-bg1.png", "kjg-bg2.png"],
            AuthList: {},
            isShowData: false,
            btnTxt: "验证码",
            // 是否禁用  即点击之后一段时间内无法再点击
            disabled: false,
            time: 0,
            imgUrl: "",
            setTime: null,
            wxStatus: 0,
        };
    },
    beforeDestroy() {
        if (this.setTime) {
            clearInterval(this.setTime);
        }
    },
    mounted() {
        this._getSmallAppLoginQrCode();
        // if (tool.getStore("token")) {
        //     this.$router.push({
        //         path: "/Home",
        //     });
        // }
    },
    methods: {
        getExpire() {
            this.wxStatus = 0;
            this._getSmallAppLoginQrCode();
        },
        _getSmallAppLoginQrCode() {
            const param = { appId: "wx04f435eb17e23fa5" };
            getSmallAppLoginQrCode(param).then(res => {
                console.log(res, "5555");
                const binaryData = res.data.qrCode;

                this.imgUrl = "data:image/png;base64," + binaryData;
                this.setTime = setInterval(() => {
                    param.loginCode = res.data.loginCode;
                    param.merchantNo = "E888888880";

                    console.log(11);
                    this._getLoginQrCodeStatus(param);
                    // 方法区
                }, 6000 * 1);
                // console.log(imgUrl,'imgUrl');
            });
        },
        _getLoginQrCodeStatus(param) {
            getLoginQrCodeStatus(param).then(res => {
                if (res.code == 0) {
                    console.log(res.data.status, " res.data.status");
                    if (res.data.status == 500) {
                        if (this.setTime) {
                            clearInterval(this.setTime);
                        }
                    } else if (res.data.status == 2) {
                        this.$message({
                            message: "登录成功~",
                            type: "success",
                        });
                        clearInterval(this.setTime);
                        // token存入缓存
                        localStorage.setItem("token", res.data.token);
                        localStorage.setItem("userInfo", JSON.stringify(res.data.user));
                        this.$router.push({
                            path: "/Home",
                        });
                    }
                    this.wxStatus = res.data.status;
                }
            });
        },
        gourl() {
            let url = "https://beian.miit.gov.cn/#/Integrated/index";
            // 指定要打开的页面的URL

            // 使用window.open()方法打开新窗口
            window.open(url, "_blank");
        },
        //获取手机验证码方法
        getCode() {
            // 校验手机号码
            if (!this.CellPhone) {
                //号码校验不通过
                this.$message({
                    message: "请输入手机号",
                    type: "warning",
                });
                //正则判断 从1开始，第二位是35789中的任意一位，以9数字结尾
            } else if (!/1[35789]\d{9}/.test(this.CellPhone)) {
                // 失去焦点后自动触发校验手机号规则
            } else {
                this.time = 60;
                this.disabled = true;
                //调用倒计时方法
                this.timer();
                let param = {
                    phone: this.CellPhone,
                    merchantNo,
                    // pwd: this.$base64Encode(this.VerificationCode),
                    // merchantNo: 'E888888880', //用户类型
                };
                sendLoginCode(param).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: "验证码发送成功",
                            type: "success",
                        });
                    } else {
                        this.$message({
                            message: "发送失败",
                            type: "warning",
                        });
                    }
                });
                // 封装的axios接口
                // GetPhone({
                //   CellPhone: this.CellPhone,
                // }) .then(({data}) => {
                //   if (data.code === 200) {
                //     this.$message({
                //       message: '验证成功',
                //       type: 'success',
                //     })
                //   } else {
                //     this.$message({
                //       message: '发送失败',
                //       type: 'warning',
                //     })
                //   }
                // })
            }
        },
        // 倒计时方法
        timer() {
            if (this.time > 0) {
                this.time--;
                // console.log(this.time);
                this.btnTxt = this.time + "s后重新获取";
                setTimeout(this.timer, 1000);
            } else {
                this.time = 0;
                this.btnTxt = "验证码";
                this.disabled = false;
            }
        },

        // 登录
        login() {
            if (this.CellPhone == "") {
                this.$message({
                    message: "请输入您的账号！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            if (this.VerificationCode == "") {
                this.$message({
                    message: "请输入您的验证码！",
                    type: "error",
                    offset: "400",
                });
                return;
            }
            let param = {
                username: this.$base64Encode(this.CellPhone),
                pwd: this.$base64Encode(this.VerificationCode),
                merchantNo: this.$base64Encode(merchantNo), //用户类型
            };
            console.log(param, "param");
            officialWebsiteLogin(param)
                .then(res => {
                    console.log(res, "res");
                    if (res.code == 0) {
                        // token存入缓存
                        localStorage.setItem("token", res.token);
                        sessionStorage.setItem("userInfo", JSON.stringify(res.user));
                        this.$router.push({
                            path: "/Home",
                        });
                    }

                    // //用户权限和用户信息存入store
                    // this.$store.commit("setRouter", res.router);
                    // this.$store.commit("setPerms", res.perms);
                    // this.$store.commit("setUserInfo", res.user);
                    // sessionStorage.setItem("router", JSON.stringify(res.router));
                    // sessionStorage.setItem("perms", JSON.stringify(res.perms));
                })
                .catch(res => {
                    // // code等于1008，弹出修改密码弹窗
                    // if (res.code == "1008") {
                    //   this.isShowData = true;
                    // }
                });
        },
        // 获取子组件传过来的值
        getData(val) {
            this.isShowData = val;
        },
        // 根据返回权限组装菜单
        recursive(arr, isOver) {
            let list = this.AuthList;
            arr.forEach(item => {
                // 将返回的权限状态设置为true
                list[item.path] = true;
                if (item.children.length > 0) {
                    this.recursive(item.children, false); // 递归子数组
                }
            });
            // 递归结束后再赋值
            if (isOver == undefined) {
                this.AuthList = list;
                sessionStorage.setItem("AuthList", JSON.stringify(this.AuthList));
                this.$store.commit("setAuthList", this.AuthList);
            }
        },
    },
};
</script>

<style scoped>
.container {
    position: relative;
    width: 1920px;
    height: 100vh;
}

.header {
    position: absolute;
    display: flex;
    align-items: center;
    top: 8px;
    width: 100%;
    z-index: 2023;
    /* height: 64px; */
    height: 7%;
    /* 	padding: 10px 24px;*/
    background-size: 100% 100% !important;
}

.header img {
    width: 245px;
    height: 35px;
    margin-right: 12px;
    margin-left: 12px;
}

.header .title {
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    text-shadow: 0px 4px 4px rgba(231, 28, 28, 0.25);
    color: #ffffff;
}

.section {
    width: 100%;
    height: 100%;
    align-items: center;
    /* 	padding: 0 136px;
		box-sizing: border-box; */
    justify-content: space-between;
    /* 	background-image: url(../assets/img/img-banner.png);
		background-size: 100% 100%;
		background-repeat: no-repeat; */
    position: relative;
}

.section .content {
    width: 100%;
    padding: 0 240px;
    box-sizing: border-box;
    position: absolute;
    z-index: 999;
    justify-content: flex-end;
}

.section .banner {
    width: 100%;
    height: 100%;
}

.banner el-carousel-item {
    width: 100%;
    height: 100%;
}

.banner img {
    width: 100%;
    height: 100%;
}

.section .tip div:first-child {
    font-size: 38px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 16px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.section .tip div:last-child {
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 23px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.tip div:last-child .space {
    letter-spacing: 35px;
}

.rightBox {
    width: 480px;
    height: 537px;
    background: #ffffff;
    border-radius: 20px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    justify-content: center;
    position: relative;
}
.login-logo {
    position: absolute;
    width: 60%;
    left: 20%;
    top: 18%;
}
.rightBox .title {
    font-size: 24px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    margin-top: -34px;
    margin-left: 10px;
}

.title span {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-left: 16px;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.rightBox .inputBox {
    width: 388px;
    margin: auto;
    margin-top: 182px;
}
.img-box {
}
.login-wxerr {
    position: absolute;
    position: absolute;
    width: 55%;
    left: 22.5%;
    top: 33%;
    border-radius: 20px;
}
.inputBox .name {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    margin-bottom: 26px;
}
/deep/ .el-input__inner {
    width: 388px;
    height: 40px;
    background: #ffebeb;
    color: #000;
    border-radius: 6px;
    margin-bottom: 16px;
    border: none !important;
}

/deep/.inputBox .login {
    width: 388px;
    height: 46px;
    background: #ba2a17 !important;
    border-radius: 20px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-size: 16px;
    line-height: 1px;
    font-weight: 500;
    color: #ffffff !important;
    margin-top: 34px;
    margin-bottom: 62px;
    border: none;
}

/deep/ .el-carousel__container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
/deep/ .el-input__suffix {
    height: 40px;
}
.inputBox .unitName {
    font-size: 16px;
    padding-bottom: 20px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ba2a17;
    text-align: center;
    margin-top: 20px;
}
.footer {
    position: absolute;
    bottom: 0;
    z-index: 2023;
    width: 100%;
    /* height: 53px; */
    height: 6%;
    background: linear-gradient(90deg, #ba2a17, #ba2a17);
    display: flex;
    align-items: center;
    justify-content: center;
}
.footer span {
    cursor: pointer;
}
.footer .Comments {
    text-align: center;
    font-size: 18px;
    color: #ffffff;
}
/deep/.el-input__suffix {
    right: 0 !important;
    color: #ba2a17;
    border: 0;
}
.Time {
    color: #ba2a17 !important;
}
/deep/.el-button--default {
    border: 1px solid #eee;
}
/deep/.el-button.is-plain:focus {
    border: 1px solid #dfdede;
}
/deep/.el-button.is-plain:hover {
    background: #ba2a1749;
    color: #ba2a17;
    border: 1px solid #ba2a17;
}
.erImg {
    width: 65%;
}
</style>
